__turbopack_context__.v({
  "blok-big-title": "ProductListingPage-module__mg947W__blok-big-title",
  "blok-subtitle": "ProductListingPage-module__mg947W__blok-subtitle",
  "blok-title": "ProductListingPage-module__mg947W__blok-title",
  "card__image": "ProductListingPage-module__mg947W__card__image",
  "card__skeleton": "ProductListingPage-module__mg947W__card__skeleton",
  "expanded": "ProductListingPage-module__mg947W__expanded",
  "filter_modal_skeleton": "ProductListingPage-module__mg947W__filter_modal_skeleton",
  "filters-nav": "ProductListingPage-module__mg947W__filters-nav",
  "filters__skeletons": "ProductListingPage-module__mg947W__filters__skeletons",
  "heading__wrapper": "ProductListingPage-module__mg947W__heading__wrapper",
  "heroText": "ProductListingPage-module__mg947W__heroText",
  "heroTextWrapper": "ProductListingPage-module__mg947W__heroTextWrapper",
  "hero__text": "ProductListingPage-module__mg947W__hero__text",
  "infinite_loading__trigger": "ProductListingPage-module__mg947W__infinite_loading__trigger",
  "infinite_loading__wrapper": "ProductListingPage-module__mg947W__infinite_loading__wrapper",
  "main-content": "ProductListingPage-module__mg947W__main-content",
  "mobile__search": "ProductListingPage-module__mg947W__mobile__search",
  "no-border": "ProductListingPage-module__mg947W__no-border",
  "product-count": "ProductListingPage-module__mg947W__product-count",
  "products__wrapper": "ProductListingPage-module__mg947W__products__wrapper",
  "root": "ProductListingPage-module__mg947W__root",
  "tags__wrapper": "ProductListingPage-module__mg947W__tags__wrapper",
});
